import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'
import {StorefrontRounded, LocalPhoneRounded, WhatsApp, RoomRounded, ArticleRounded} from '@mui/icons-material'
import './infoStore.scss'

const InfoStore = () => {
    const info = getLocal('info')
    return <div className={'info-store'}>
        {(info.name) && <div className={'div-store'}>
            <StorefrontRounded className={'icon'}/>
            <label className={'name'}>
                {info.name}
            </label>
        </div>}
        {(info.cnpj) && <div className={'div-store'}>
            <ArticleRounded className={'icon'}/>
            <label className={'phone'}>
                {info?.cnpj}
            </label>
        </div>}
        {(info.telphone) && <div className={'div-store'}>
            <LocalPhoneRounded className={'icon'}/>
            <label className={'phone'}>
                {info.telphone}
            </label>
        </div>}
        {(info.whatsapp) && <div className={'div-store'}>
            <WhatsApp className={'icon'}/>
            <label className={'phone'}>
                {info.whatsapp}
            </label>
        </div>}
        {(info.address) && <div className={'div-store'}>
            <RoomRounded className={'icon'}/>
            <label className={'phone'}>
                {info.address}
            </label>
        </div>}
        <div className={'div-store'} id={import.meta.env.VITE_VERSION_CODE}>
            <label className={'phone'}>
                {`Versão: ${import.meta.env.VITE_VERSION_NAME}`}
            </label>
        </div>
    </div>
}

export default InfoStore
